<template>
  <div
    class="checkbox-root d-flex align-center"
    :class="{ disabled, 'label-less': !label }"
    @click="!disabled && $emit('change', !checked)"
  >
    <div class="icon d-flex align-center justify-center" :class="{ checked }" />
    <div v-if="label" class="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "checked",
    event: "change"
  },

  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-root {
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
  }

  &.label-less {
    width: 20px;
  }
}

.icon {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  border: #ccc 1px solid;

  &.checked {
    background-color: #48AE84;
    border-color: transparent;

    &::after {
      display: block;
      content: "";
      width: 8px;
      height: 12px;
      border-right: #fff 3px solid;
      border-bottom: #fff 3px solid;
      transform: translateY(-2px) rotate(45deg);
    }
  }
}

.label {
  margin-left: 10px;
  color: #555;
  font-size: 14px;
}
</style>
